<template>
  <v-container class="fill-height eservice_type" fluid>
    <v-layout column class="eservice_inner_wrap">
      <h2 class="outside_title d-flex">
        {{$t('due_date.title')}}
        <Bookmark service_type_code='6433' />
        <v-spacer></v-spacer>
        <span class="loc_postion">
            <span class="front_loc">{{$t('due_date.title')}} > </span>
            <span class="back_loc">{{$t('due_date.title')}}</span>
        </span>
      </h2>
      <v-layout column class="ma-0 pos-r center__wrapper">
        <v-flex class="inner_basic_wrap pl-0 pr-0 pt-0">
          <v-row>
            <v-col cols="12" class="month__cols__wrap">
              <v-btn
                dense
                dark
                outlined
                color="#ccc"
                class="button_search_year mr--10 actv"
                @click="fnSearchDuedateYear(currentYear)"
              >{{currentYear}}</v-btn>
              <v-btn
                dense
                dark
                outlined
                color="#ccc"
                class="button_search_year mr--10"
                @click="fnSearchDuedateYear(nextYear)"
              >{{nextYear}}</v-btn>
            </v-col>
            <v-col cols="12" class="app_stage_wrap">
              <v-row class="agent__app__stbox ty2">
                <v-col cols="12" class="pa-0">
                  <div class="month__chip">
                    <div class="month__chip__item" @click="fnSetCalendarDate(1)">Jan</div>
                    <div class="month__chip__item" @click="fnSetCalendarDate(2)">Feb</div>
                    <div class="month__chip__item" @click="fnSetCalendarDate(3)">Mar</div>
                    <div class="month__chip__item" @click="fnSetCalendarDate(4)">Apr</div>
                    <div class="month__chip__item" @click="fnSetCalendarDate(5)">May</div>
                    <div class="month__chip__item" @click="fnSetCalendarDate(6)">Jun</div>
                    <div class="month__chip__item" @click="fnSetCalendarDate(7)">Jul</div>
                    <div class="month__chip__item" @click="fnSetCalendarDate(8)">Aug</div>
                    <div class="month__chip__item" @click="fnSetCalendarDate(9)">Sep</div>
                    <div class="month__chip__item" @click="fnSetCalendarDate(10)">Oct</div>
                    <div class="month__chip__item" @click="fnSetCalendarDate(11)">Nov</div>
                    <div class="month__chip__item" @click="fnSetCalendarDate(12)">Dec</div>
                  </div>
                  <div class="calendar__new">
                    <h2>{{currentYearMonth}}</h2>
                    <div class="calendar__new__inner">
                      <div class="week__box re__type" v-for="(item, index) in duedateCalendar" :key="index">
                        <v-row>
                          <v-col v-for="(item_sub, index_sub) in item" :key="index_sub">
                            <div class="week__th">{{item_sub.day_name}}</div>
                            <div :class="[(item_sub.annuity_cnt + item_sub.payment_cnt + item_sub.notification_cnt > 0) ? 'day__text actv_c' : 'day__text']">{{item_sub.dd}}</div>
                          </v-col>
                        </v-row>
                      </div>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" md="4" class="pt-0">
              <div class="date__call">
                <div class="title__count ty1" style="cursor:pointer;" @click="fnSetFilter('notification')">
                  <span>{{$t('due_date.fields.respond_to_office_action')}}</span>
                  <span>{{cntDailyAction}}</span>
                </div>
                <div class="app__num__wrap" style="display:none">
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="pt-0">
              <div class="date__call">
                <div class="title__count ty2" style="cursor:pointer;" @click="fnSetFilter('annuity')">
                  <span>{{$t('due_date.fields.annual_fee')}}</span>
                  <span>{{cntDailyAnnuity}}</span>
                </div>
                <div class="app__num__wrap" style="display:none">
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="4" class="pt-0">
              <div class="date__call">
                <div class="title__count ty3" style="cursor:pointer;" @click="fnSetFilter('payment')">
                  <span>{{$t('due_date.fields.payment')}}</span>
                  <span>{{cntDailyPayment}}</span>
                </div>
                <div class="app__num__wrap" style="display:none">
                </div>
              </div>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <div class="date__call">
                <div class="app__num__wrap">
                  <ul>
                    <li :class="[item.gubun == 'payment' ? 'status_03' : item.gubun == 'annuity' ? 'status_02' : 'status_01', 'cursor_pointer']" v-for="(item, index) in duedateDailyList" :key="index" @click="fnGoList(item)">
                      <p>
                        <span style="color:#F4AC68;">{{item.due_date}},</span>
                        <v-spacer class="hidden_lr3"></v-spacer>
                        {{item.application_no}},
                        <v-spacer class="hidden_lr3"></v-spacer>
                        <span style="color:#1fbff4;" v-if="item.ind_paid === 'Y'">{{$t('due_date.fields.already_done')}}</span>
                        <span style="color:#F4AC68;" v-if="item.ind_paid === 'N'">{{$t('due_date.fields.need_to_be_done')}}</span>
                      </p>
                      <p>{{$vuetify.rtl ? item.name_ar : item.name_en}}</p>
                    </li>
                  </ul>
                </div>
              </div>

            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12" class="d-flex">
              <v-spacer></v-spacer>
              <v-btn
                dark
                class="elevation-0 br_none ft-size12 text-capitalize"
                color="#a01c2a"
                height="50"
                width="150"
                @click="fnShowOverDue"
                >{{$t('due_date.fields.overdue_list')}}</v-btn>
            </v-col>
          </v-row>
        </v-flex>
      </v-layout>


      <v-dialog
        v-model="overduelist"
        flat
        persistent
        max-width="650"
        content-class="br_none"
      >
        <v-card class="br_none modal_comfirm_wrap type4" solo flat>
          <v-btn class="modal_close"  fab color="white" @click="fnCloseOverdue()">
            <v-icon dark>mdi-close</v-icon>
          </v-btn>
          <h2 class="header_title02 type4">{{$t('due_date.fields.overdue')}}</h2>
        </v-card>
        <div class="dialog__conatent">
          <v-row>
            <v-col cols="12" class="d-flex align-center">
              <label class="nec_title" style="white-space:nowrap">{{$t('due_date.fields.application_no')}}</label>
              <v-spacer class="hidden_lr5"></v-spacer>
              <div class="input_text_type_basic wp100">
                <v-text-field
                  placeholder=""
                  dense
                  outlined
                  hide-details
                  clearable
                  class="ft-size12 wp100"
                  v-model="overdue_application_no"
                >
                </v-text-field>
              </div>
              <v-spacer class="hidden_lr5"></v-spacer>
              <v-btn class="t_search_btn wp50" color="#a01c2a" dense dark @click="fnGetOverdue()">
                <v-icon>mdi-magnify</v-icon><v-spacer class="hidden_lr2"></v-spacer>
                {{ $t('common.button.search') }}
              </v-btn>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="12">
              <v-data-table
                :headers="$getHeaderType2(headerTxt, headersEn, headersAr)"
                :items="overdueList"
                hide-default-footer
                class="new__type__table poptype"
                :mobile-breakpoint="mobileBreakPoint"
                :page.sync="paging.page"
                :items-per-page="paging.pageSize"
                @page-count="paging.pageCount = $event"
                @click:row="fnGoList"
              ></v-data-table>
              <div class="v-data-table-footer page_nation_wrap mt-20">
                <pagination :paging.sync="paging" />
              </div>
            </v-col>
          </v-row>
        </div>

      </v-dialog>
    </v-layout>

  </v-container>

</template>

<script>
import Pagination from '@/components/layout/Pagination'
import requestApi from "@/utils/requestApi"
import utils from "@/utils/utils"
import eventBus from "@/utils/eventBus"
import Bookmark from '@/components/layout/Bookmark'

export default {
  name: 'DueDate',
  components :{
    Pagination,
    Bookmark
  },
  data () {
    return {
      mobileBreakPoint:0,
      overduelist : false,
      sdd : true,
      duedateCalendar: [],
      duedateDateYear: '',
      duedateDateMonth: '',
      duedateDateDay: '',
      duedateDailyList: [],
      duedateDailyListOrg: [],
      cntDailyAction: 0,
      cntDailyAnnuity: 0,
      cntDailyPayment: 0,
      currentYearMonth: '',
      currentYear: '',
      nextYear: '',
      overdueList: [],
      overdue_application_no: '',
      headerTxt : {
        prefix : 'due_date.fields.',
        txt : [ 'application_no', 'task','due_date' ]
      },
      headersAr: [
        { text: 'Application No', align: 'center', value: 'application_no', width: '120' },
        { text: 'Task', align: 'center', value: 'name_ar' },
        { text: 'Due Date', align: 'center', value: 'due_date', width: '100' }
      ],
      headersEn: [
        { text: 'Application No', align: 'center', value: 'application_no', width: '120' },
        { text: 'Task', align: 'center', value: 'name_en' },
        { text: 'Due Date', align: 'center', value: 'due_date', width: '100' }
      ],
      paging: {
        page: 1,
        pageSize: 10,
        pageCount: 0,
        totalCount: 0
      },
    }
  },
  mounted() {
    window.scrollTo(0, 0)
    if (this.$route.query.search_date) {
      let searchDate = this.$route.query.search_date
      this.duedateDateYear = this.$moment(searchDate, 'YYYYMMDD').format('YYYY')
      this.duedateDateMonth = this.$moment(searchDate, 'YYYYMMDD').format('MM')
      this.duedateDateDay = this.$moment(searchDate, 'YYYYMMDD').format('DD')
      this.currentYear = this.duedateDateYear
      this.nextYear = this.$moment(searchDate, 'YYYYMMDD').add(1, 'years').format('YYYY')
    } else {
      let d = new Date()
      this.duedateDateYear = String(d.getFullYear())
      this.duedateDateMonth = String(utils.fillZero(d.getMonth()+1, 2))
      this.duedateDateDay = String(utils.fillZero(d.getDate(),2))
      this.currentYear = String(d.getFullYear())
      this.nextYear = String(d.getFullYear()+1)
    }

    this.fnGetDuedateCalendar()
    this.fnGetDuedateMonthly(this.$route.query.gubun)
    this.fnGetTakeoverDate()

  },
  methods: {
    getColor (colorbadge) {
      if (colorbadge === 'Important') return '#b22325'
      else if (colorbadge === 'Warning') return '#f59a41'
      else if (colorbadge === 'Inactive') return '#c1c1c1'
      else if (colorbadge === 'Active') return '#99bc44'
      else if (colorbadge === 'Success') return '#00af50'
      else if (colorbadge === 'In Progress') return '#333'
      else if (colorbadge === 'Complete') return '#2a58ad'
      else if (colorbadge === 'Failure') return '#c1c1c1'
      else if (colorbadge === 'claim') return '#a01c2a'
      else if (colorbadge === 'smd') return '#a2c1e2'
      else if (colorbadge === 'pay') return '#98bbbf'

      else return '#1f94a6'
    },

    fnSetFilter(gubun) {
      let list = this.duedateDailyListOrg.filter(item => {
        return item.gubun === gubun
      })

      this.duedateDailyList = list
    },

    fnSetCalendarDate(month) {
      for (let index = 0; index < document.getElementsByClassName('month__chip__item').length; index++) {
        document.getElementsByClassName('month__chip__item')[index].classList.remove('actv')
      }
      document.getElementsByClassName('month__chip__item')[month-1].classList.add('actv')

      var d = new Date()
      this.duedateDateMonth = String(utils.fillZero(month,2))
      this.duedateDateDay = String(utils.fillZero(d.getDate(),2))
      this.fnGetDuedateCalendar()
      this.fnGetDuedateMonthly()
      this.fnGetTakeoverDate()
    },

    fnSearchDuedateYear(yyyy) {
      var d = new Date()
      var currentYear = d.getFullYear()

      var btnIdx = 0

      if(currentYear == yyyy) { //올해
        this.duedateDateYear = String(d.getFullYear())
        this.duedateDateMonth = String(utils.fillZero(d.getMonth()+1, 2))
        this.duedateDateDay = String(utils.fillZero(d.getDate(),2))
        btnIdx = 0
      } else { //내년
        this.duedateDateYear = yyyy
        this.duedateDateMonth = "1"
        this.duedateDateDay = "01"
        btnIdx = 1
      }

      this.fnGetDuedateCalendar()
      this.fnGetDuedateMonthly()
      this.fnGetTakeoverDate()

      for (let index = 0; index < document.getElementsByClassName('month__chip__item').length; index++) {
        document.getElementsByClassName('month__chip__item')[index].classList.remove('actv')
      }

      for (let index = 0; index < document.getElementsByClassName('button_search_year').length; index++) {
        document.getElementsByClassName('button_search_year')[index].classList.remove('actv')
      }
      document.getElementsByClassName('button_search_year')[btnIdx].classList.add('actv')
    },

    fnSearchDuedateCalendar(yyyymm, dd) {
      this.duedateDateYear = yyyymm.substring(0,4)
      this.duedateDateMonth = yyyymm.substring(4,6)
      this.duedateDateDay = dd
      this.fnGetDuedateCalendar()
      this.fnGetDuedateMonthly()
      this.fnGetTakeoverDate()
    },

    fnGetDuedateCalendar() {
      var searchMonth = this.duedateDateYear+''+this.duedateDateMonth
      requestApi({
        url: '/duedate/calendar?search_month='+searchMonth,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === "200") {
            this.duedateCalendar = []

            var weekend = [[],[],[],[],[],[]]
            var idx = 0

            res.data.list.forEach(item => {
              if (item.day == "1") {
                idx++
                weekend[idx].push(item)
              } else {
                weekend[idx].push(item)
              }
            })

            this.duedateCalendar = weekend.filter(function(item){
              return item.length !== 0
            })
          } else {
            if (res.res_code === "401012") {
              utils.setTokenRefresh().then(() => {
                this.fnGetDuedateCalendar()
              })
            } else {
              eventBus.$emit("SHOW_ERROR_SNACKBAR", res);
            }
          }

          document.getElementsByClassName('month__chip__item')[parseInt(this.duedateDateMonth)-1].classList.add('actv')
        }
      })
    },

    fnGetDuedateMonthly(gubun) {
      let params = {
        'search_month': this.duedateDateYear + this.duedateDateMonth
      }
      requestApi({
        url: '/duedate/monthly',
        method: 'GET',
        data: params,
        callback: (res) => {
          if (res.res_code === "200") {
            this.duedateDailyList = res.data.list
            this.duedateDailyListOrg = res.data.list
            this.cntDailyAction = 0
            this.cntDailyAnnuity = 0
            this.cntDailyPayment = 0

            res.data.list.forEach(item => {
              if (item.gubun === 'annuity') {
                this.cntDailyAnnuity ++
              } else if(item.gubun === 'payment') {
                this.cntDailyPayment ++
              } else if (item.gubun === 'notification') {
                this.cntDailyAction ++
              }
            })

            if (gubun) {
              this.fnSetFilter(gubun)
            }
          } else {
            if (res.res_code === "401012") {
              utils.setTokenRefresh().then(() => {
                this.fnGetDuedateMonthly()
              });
            } else {
              eventBus.$emit("SHOW_ERROR_SNACKBAR", res);
            }
          }
        }
      })
    },

    fnGetTakeoverDate() {
      var searchDate = this.duedateDateYear+""+this.duedateDateMonth+""+this.duedateDateDay
      requestApi({
        url: '/dashboard/takeover/date?search_date='+searchDate,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === "200") {
            this.currentYearMonth = res.data.date_desc
            if (this.currentYearMonth.indexOf(',') > -1) {
              this.currentYearMonth = res.data.date_desc.split(',')[0]
            }
          } else {
            if (res.res_code === "401012") {
              utils.setTokenRefresh().then(() => {
                this.fnGetTakeoverDate()
              });
            } else {
              eventBus.$emit("SHOW_ERROR_SNACKBAR", res);
            }
          }
        }
      })
    },

    fnShowOverDue() {
      this.overduelist = true
      this.overdue_application_no = ''
      this.fnGetOverdue()
    },

    fnGetOverdue() {
      if (this.overdue_application_no === null) {
        this.overdue_application_no = ''
      }

      requestApi({
        url: '/duedate/overdue?application_no='+ this.overdue_application_no,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === "200") {
            this.overdueList = res.data.list
            this.paging.page = 1
            this.paging.totalCount = res.data.list.length
          } else {
            if (res.res_code === "401012") {
              utils.setTokenRefresh().then(() => {
                this.fnGetOverdue()
              });
            } else {
              eventBus.$emit("SHOW_ERROR_SNACKBAR", res);
            }
          }
        }
      })
    },

    fnCloseOverdue() {
      this.overdue_application_no = ''
      this.overdueList = []
      this.paging.page = 1
      this.paging.pageSize = 10
      this.paging.pageCount = 0
      this.pagingtotalCount = 0
      this.overduelist = false
    },

    fnGoList(item) {
      if (item.gubun === 'annuity') {
        this.$router.push('/maintenance/payannualfee?search_application_no='+ item.application_no)
      } else if (item.gubun === 'payment') {
        this.$router.push('/payment/list?search_application_no='+ item.application_no)
      } else if (item.gubun === 'notification') {
        this.$router.push('/myapplication/list?search_key=application_no&search_keyword='+ item.application_no)
      }
    }
  },
}
</script>
